const PROXY_URL = "https://brfenergi.se/iprog/group/77/";
const PROXY_KEY = "3d2a031b4cmsh5cd4e7b939ada54p19f679jsn9a775627d767";

export { PROXY_URL, PROXY_KEY };
